import { useSelector } from 'react-redux';
import { State } from '../core/reducers';

export const useAccountDeactivatedCheck = () => {
	const { account } = useSelector((state: State) => state.admin.account);
	return { accountDeactivated: !!account?.deactivatedAt };
};
